// @flow

import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { type Receipt } from '@tectonics/prs/receipts';
import { adjustFinalReceipt } from '@tectonics/prs/incoming-payment/final-receipt-resolver';

export function getFinalReceipt(incomingPayment: IncomingPayment): Receipt {
  if (incomingPayment.status === 'OP')
    throw new Error(`FinalReceipt: it's not available in a payment with status: "${incomingPayment.status}"`);

  const finalReceipt = incomingPayment['final_receipt'];
  return adjustFinalReceipt(incomingPayment, finalReceipt);
}
